import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { rehydrateDateAfterJsonization as Y } from "../util/date-utils.js";
var ti = /*#__PURE__*/function () {
  function ti(t, i, s, l, h) {
    _classCallCheck(this, ti);
    this.endpoint = t, this.Vn = i, this.publicKey = s, this.Vl = l, this.dl = h, this.endpoint = t || null, this.Vn = i || null, this.publicKey = s || null, this.Vl = l || null, this.dl = h || null;
  }
  _createClass(ti, [{
    key: "dt",
    value: function dt() {
      return {
        e: this.endpoint,
        c: this.Vn,
        p: this.publicKey,
        u: this.Vl,
        v: this.dl
      };
    }
  }], [{
    key: "qn",
    value: function qn(t) {
      return new ti(t.e, Y(t.c), t.p, t.u, t.v);
    }
  }]);
  return ti;
}();
export { ti as default };